import { View, Card, CardContent } from "@/components/ui";
import { Info } from "@/components/shared/icons";
import { Typography } from "../typography";

export const InfoCard = ({
  title,
  description,
}: {
  title?: string;
  description: string;
}) => {
  return (
    <Card variant="info" className="w-full flex-1">
      <CardContent className="flex flex-row items-start gap-2 p-3">
        <View className="flex items-center justify-center">
          <Info className="text-primary" weight="fill" size={20} />
        </View>
        <View className="max-w-[320px] pr-4 md:max-w-max md:pr-0">
          {title && (
            <Typography variant="body-md" color="info">
              {title}
            </Typography>
          )}
          <Typography variant="body-sm" color="info">
            {description}
          </Typography>
        </View>
      </CardContent>
    </Card>
  );
};
